<template>
  <tr class="property-table__item">
    <td>
      {{ itemKey }}
    </td>

    <td>
      {{ itemValue }}
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    itemKey: {
      type: String,
      required: true
    },
    itemValue: {
      type: [String, Number],
      required: true
    }
  }
}
</script>

<style lang="scss">
.property-table__item {
  border-top: 1px solid color(border-gray);

  &:first-child {
    border-top: 0;
  }
}

.property-table__item td {
  @include body-smaller;
  padding: measure(quarter);

  &:first-child {
    @include body-smaller-bold;
    border-right: 1px solid color(border-gray);
  }
}

// .product-tabs__specification .property-table__item td {
//   @include media(to-medium) {
//     padding: measure(quarter) measure(half);
//   }
// }
</style>
